import {useRef} from 'react';

export function useWhatChanged(prefix: string, refData: Record<string, any>) {
  const ref = useRef({} as Record<string, any>);
  const keys = new Set([...Object.keys(ref.current), ...Object.keys(refData)]);
  const diff: Record<string, any> = {};
  keys.forEach((key) => {
    const prevValue = ref.current[key];
    const value = refData[key];
    if (value !== prevValue) {
      diff[key] = value;
    }
    ref.current[key] = value;
  });
  if (Object.keys(diff).length > 0) {
    console.log(prefix, diff);
  }
}
